import React from 'react';
import { PLATFORMS, ALL_PLATFORMS } from '../../constants/platforms';
import { PlatformIconComponent, DefaultPlatformIcon } from '../icons/PlatformIcons';
import styles from './EmptyState.module.css';

function EmptyState({ platform }) {
  const isAll  = !platform || platform === ALL_PLATFORMS;
  const info   = isAll ? null : PLATFORMS[platform];
  const name   = info ? info.label : 'any platform';

  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        {isAll
          ? <DefaultPlatformIcon size={40} className={styles.icon} />
          : <PlatformIconComponent platform={platform} size={40} className={styles.icon} />
        }
      </div>
      <p className={styles.message}>
        No active deals on <strong>{name}</strong> right now.
      </p>
      <p className={styles.sub}>Check back soon — deals refresh every hour.</p>
    </div>
  );
}

export default EmptyState;
